import { render, staticRenderFns } from "./Cessionarios.vue?vue&type=template&id=c6e67c4c&scoped=true&"
import script from "./Cessionarios.vue?vue&type=script&lang=js&"
export * from "./Cessionarios.vue?vue&type=script&lang=js&"
import style0 from "./Cessionarios.vue?vue&type=style&index=0&id=c6e67c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e67c4c",
  null
  
)

export default component.exports